import Button, { ButtonGroup } from '@atlaskit/button';
import LoadingButton from '@atlaskit/button/loading-button';
import Form, { FormFooter } from '@atlaskit/form';
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React from 'react';
import { cancelHoursOfOperationFormAnalyticsConfig, saveHoursOfOperationFormAnalyticsConfig } from '../../../PartnerProfile.events';
import { checkFormValidation, getSupportFieldsFromFormData } from './HoursOfOperationForm.utils';
import ServiceAvailabilityFormSection from './ServiceAvailabilityFormSection/ServiceAvailabilityFormSection';
import ServiceLevelAgreementFormSection from './ServiceLevelAgreementFormSection/ServiceLevelAgreementFormSection';
const HoursOfOperationForm = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleCancel = () => {
    fireAnalyticsEvent(cancelHoursOfOperationFormAnalyticsConfig);
    props.onClose();
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: data => {
      const formValidationErrors = checkFormValidation(data);
      if (formValidationErrors) return formValidationErrors;
      const formFields = {
        sla: data.sla,
        targetResponseTime: Number(data.targetResponseTime),
        supportHours: data.providesSupportHours ? getSupportFieldsFromFormData(data) : undefined
      };
      fireAnalyticsEvent(saveHoursOfOperationFormAnalyticsConfig);
      props.onSubmit(formFields);
    }
  }, _ref => {
    let {
      formProps,
      dirty
    } = _ref;
    return /*#__PURE__*/React.createElement("form", formProps, /*#__PURE__*/React.createElement(ServiceLevelAgreementFormSection, {
      sla: props.sla
    }), /*#__PURE__*/React.createElement(ServiceAvailabilityFormSection, props), /*#__PURE__*/React.createElement(FormFooter, {
      align: "start"
    }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(LoadingButton, {
      type: "submit",
      appearance: "primary",
      isDisabled: !dirty,
      isLoading: props.submitting
    }, "Save"), /*#__PURE__*/React.createElement(Button, {
      onClick: handleCancel,
      appearance: "subtle"
    }, "Cancel"))));
  });
};
export default HoursOfOperationForm;